const CUSTOMER_PLAN_LABELS: Record<string, string> = {
  free: 'Free',
  standard: 'Standard',
  standard_india: 'Standard',
  byok: 'BYOK',
  plus: 'Plus',
  pro: 'Pro',
  unlimited: 'Unlimited',
};

export const normalizePlanTier = (tier?: string | null): string => (tier || 'free').trim().toLowerCase();

export const getCustomerPlanLabel = (tier?: string | null): string => {
  const normalized = normalizePlanTier(tier);
  const knownLabel = CUSTOMER_PLAN_LABELS[normalized];
  if (knownLabel) return knownLabel;

  return normalized
    .split('_')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};

export const getPlanBadgeClass = (tier?: string | null): string => (
  normalizePlanTier(tier).replace(/[^a-z0-9_-]/g, '-')
);
